// Define profile constants

module.exports = {
  CUSTOM_USER_ATTRIBUTES_VALUE: 'CUSTOM_USER_ATTRIBUTES_VALUE',
  ADD_USER_TIME_OFF: 'ADD_USER_TIME_OFF',
  UPDATE_USER_TIME_OFF: 'UPDATE_USER_TIME_OFF',
  DELETE_USER_TIME_OFF: 'DELETE_USER_TIME_OFF',
};
